import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import('@/views/LandingView.vue'),
      meta: { layout: 'bare' },
    },
    { path: '/signup', redirect: (to) => ({ path: '/', query: { ...to.query, auth: 'signup' } }) },
    {
      path: '/registration',
      name: 'registration',
      component: () => import('@/views/RegistrationView.vue'),
      meta: { layout: 'bare' },
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: () => import('@/views/OnboardingView.vue'),
      meta: { layout: 'bare' },
    },
    { path: '/home', name: 'home', component: () => import('@/views/HomeView.vue') },
    { path: '/studio', name: 'studio', component: () => import('@/views/StudioView.vue') },
    {
      path: '/create',
      name: 'create',
      component: () => import('@/views/CreateView.vue'),
      meta: { chrome: false },
    },
    { path: '/profile', name: 'profile', component: () => import('@/views/ProfileView.vue') },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('@/views/LegalView.vue'),
      meta: { chrome: false, title: 'Web Terms of Service' },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/LegalView.vue'),
      meta: { chrome: false, title: 'Web Privacy Policy' },
    },
    {
      path: '/mobile-privacy',
      name: 'mobile-privacy',
      component: () => import('@/views/LegalView.vue'),
      meta: { chrome: false, title: 'Mobile Privacy Policy' },
    },
    {
      path: '/acceptable-use',
      name: 'acceptable-use',
      component: () => import('@/views/LegalView.vue'),
      meta: { chrome: false, title: 'AI Acceptable Use Policy' },
    },
    {
      path: '/plans',
      name: 'plans',
      component: () => import('@/views/PlansView.vue'),
      meta: { chrome: false, footer: false },
    },
    { path: '/:pathMatch(.*)*', redirect: '/studio' },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    // Same-page history entries (the Home viewer) keep the current scroll position.
    if (to.fullPath === from.fullPath) return false
    if (savedPosition) return savedPosition
    if (to.name === 'landing' && to.hash) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      return { el: to.hash, behavior: reduceMotion ? 'auto' : 'smooth' }
    }
    return { top: 0 }
  },
})
